import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarTearOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalendarTearOff"><Path d="M7 2H9V4H15V2H17V4H21V7.71922L17.9475 8.48235L14.1464 7.93934L13.2592 8.82663L11.0313 7.93548L7.97726 8.95349L3 7.53141V4H7V2Z" fill="currentColor"/><Path d="M3 9.61145V21H21V9.78078L18.0525 10.5177L14.8536 10.0607L13.7408 11.1734L10.9687 10.0645L8.02274 11.0465L3 9.61145Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarTearOff;
